import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-180c4638"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-body-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-right text-caption mt-1 opacity-60" }, "12:45", -1))
const _hoisted_3 = { class: "text-body-2" }

import { ref, watch, nextTick, onMounted, computed } from 'vue';


/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { getUserLoginToken, useChat } from '@/services/Smartlink/IA';
import { LABELS } from '@/constants/labels';
import { getAllInventoryData } from '@/services/Smartlink/Admin';
interface Message {
  rol: 'usuario' | 'asistente';
  contenido: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingButton',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();


const devices = ref([
  { name: 'Servidor Producción', ip: '192.168.1.10' },
  { name: 'Router Principal', ip: '192.168.1.1' },
  { name: 'NAS Almacenamiento', ip: '192.168.1.50' },
  { name: 'Workstation Diseño', ip: '10.0.0.15' },
]);

const menuOpen = ref(false);
// Aquí se guardará el objeto { name, ip } gracias a la prop "return-object"
const selectedDevice = ref(null);

const filterByFields = (value:any, query:any, item:any) => {
  // Convertimos todo a minúsculas para una búsqueda insensible a mayúsculas
  const searchText = query.toLowerCase();
  const name = item.raw.name.toLowerCase();
  const ip = item.raw.ip.toLowerCase();

  // Retorna true si el texto buscado coincide con el nombre O con la IP
  return name.includes(searchText) || ip.includes(searchText);
};


const chatOpen = ref(false);
const userInput = ref('');
const chatContainer = ref<HTMLElement | null>(null);
const messages = ref<Message[]>([
  { rol: 'asistente', contenido: 'Bienvenido a Smartlink V2.6. ¿En qué puedo ayudarte hoy?' }
]);

// --- CONFIGURACIÓN DE SPEECH RECOGNITION (Voz a Texto) ---
const setupSpeechRecognition = () => {
  const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
  
  if (!SpeechRecognition) {
    alert("Tu navegador no soporta el reconocimiento de voz.");
    return;
  }

  recognition = new SpeechRecognition();
  recognition.lang = 'es-ES'; // Idioma
  recognition.continuous = true;
  recognition.interimResults = true;

  recognition.onresult = (event: any) => {
    let interimTranscript = '';
    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        transcription.value += event.results[i][0].transcript + ' ';
      } else {
        interimTranscript += event.results[i][0].transcript;
      }
    }
  };
};



// --- ESTADOS ---
const isRecording = ref(false);
const transcription = ref('');
const audioUrl = ref<string | null>(null);

// --- VARIABLES DE NAVEGADOR ---
let mediaRecorder: MediaRecorder | null = null;
let audioChunks: Blob[] = [];
let recognition: any = null;

// --- LOGICA DE GRABACIÓN ---
const startAll = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    
    // 1. Iniciar Grabación de Audio
    mediaRecorder = new MediaRecorder(stream);
    audioChunks = [];
    
    mediaRecorder.ondataavailable = (e) => audioChunks.push(e.data);
    mediaRecorder.onstop = () => {
      const audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
      audioUrl.value = URL.createObjectURL(audioBlob);
    };

    mediaRecorder.start();

    // 2. Iniciar Reconocimiento de Voz
    if (!recognition) setupSpeechRecognition();
    recognition.start();

    isRecording.value = true;
  } catch (err) {
    console.error("Error al acceder al micrófono:", err);
  }
};

const stopAll = () => {
  mediaRecorder?.stop();
  recognition?.stop();
  isRecording.value = false;

  if(chatOpen.value) {
    setTimeout(() => {
      userInput.value = transcription.value;
      handleSend();
    }, 500);
  }
};




// LOGICA DE AUTO-SCROLL
// Observamos cambios en el array de mensajes
watch(messages, async () => {
  await nextTick(); // Esperamos a que el DOM se actualice
  if (chatContainer.value) {
    const el = chatContainer.value.$el; // En Vuetify el ref accede al componente, .$el al DOM
    el.scrollTo({
      top: el.scrollHeight,
      behavior: 'smooth'
    });
  }
}, { deep: true });

watch(chatOpen, async (isOpen) => {  
  mediaRecorder = null;
  if (!isOpen) {
    stopAll();
  }
})


const TOKEN = ref('');
const CHAT_ID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

async function getUserToken() {
  const allData = await getUserLoginToken()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        TOKEN.value = allData.data.token
    }
}

const isLoading = ref(false);
const messageLoading = ref('')

const { messagesChat, connectAndSendMessage} = useChat();

const computedMessagesIA = computed(() => messagesChat.value)

watch(computedMessagesIA.value, (newVal) => {
  if (newVal.length > 0) {
    const lastMessage = newVal[newVal.length - 1];
    if (lastMessage.estado === 'SUCCESS') {
      isLoading.value = false;
      messageLoading.value = '';
      messages.value.push({ rol: 'asistente', contenido: lastMessage.mensaje });
    }
    if (lastMessage.estado === 'LOADING') {
      messageLoading.value = lastMessage.mensaje;
    }
  }
});

const handleSend = () => {
  if (userInput.value.trim()) {

    isLoading.value = true;
    
    messages.value.push({ rol: 'usuario', contenido: userInput.value });

    connectAndSendMessage(TOKEN.value, CHAT_ID, userInput.value, selectedDevice.value || { name: 'No seleccionado', ip: 'N/A' });

    userInput.value = ''; // Limpiar el input

    transcription.value = ''; //Limpiar el audio
  }
};


async function getAllInventory(){

  const allData = await getAllInventoryData()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){

      devices.value = allData.data.map((item:any) => ({
        name: item.tag,
        ip: item.ip
      }));
        // TOKEN.value = allData.data.token
    }
  
}


onMounted(async () => {
  await getAllInventory();
  await getUserToken();
  // connect(TOKEN.value, CHAT_ID);
 
});




return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!chatOpen.value)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          icon: "mdi-robot-outline",
          color: "#4CAF50",
          size: "large",
          class: "chat-fab",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (chatOpen.value = true))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        (chatOpen.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "chat-window d-flex flex-column",
              theme: "dark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar, {
                  color: "#1e222d",
                  density: "compact",
                  class: "border-b"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      "prepend-avatar": "https://cdn-icons-png.flaticon.com/512/4712/4712035.png",
                      title: "Agente Smartlink",
                      subtitle: "En línea"
                    }),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      icon: "mdi-close",
                      variant: "text",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (chatOpen.value = false))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, {
                  ref_key: "chatContainer",
                  ref: chatContainer,
                  class: "flex-grow-1 overflow-y-auto pa-4 bg-chat"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: _normalizeClass(['d-flex mb-3', msg.rol === 'usuario' ? 'justify-end' : 'justify-start'])
                      }, [
                        _createVNode(_component_v_sheet, {
                          color: msg.rol === 'usuario' ? '#056162' : '#262d31',
                          class: "pa-3 msg-bubble",
                          elevation: "1"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(msg.contenido), 1),
                            _hoisted_2
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ], 2))
                    }), 128)),
                    (isLoading.value)
                      ? (_openBlock(), _createBlock(_component_v_sheet, {
                          key: 0,
                          color: "#262d31",
                          class: "pa-3 msg-bubble",
                          elevation: "1"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(messageLoading.value), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_sheet, {
                  color: "#1e222d",
                  class: "pa-3 d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_menu, {
                      modelValue: menuOpen.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((menuOpen).value = $event)),
                      "close-on-content-click": false,
                      location: "bottom start",
                      transition: "scale-transition"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          icon: "mdi-dump-truck",
                          color: "green",
                          elevation: "3",
                          size: "small"
                        }), null, 16)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          "min-width": "380",
                          class: "pa-3 shadow-lg",
                          color: "bgtopology"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                              modelValue: selectedDevice.value,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((selectedDevice).value = $event)),
                                _cache[3] || (_cache[3] = ($event: any) => (menuOpen.value = false))
                              ],
                              items: devices.value,
                              "custom-filter": filterByFields,
                              "item-title": "name",
                              "item-value": "ip",
                              label: "Buscar por Nombre o IP...",
                              "prepend-inner-icon": "mdi-magnify",
                              variant: "outlined",
                              density: "comfortable",
                              "return-object": "",
                              "auto-select-first": "",
                              "hide-details": ""
                            }, {
                              item: _withCtx(({ props, item }) => [
                                _createVNode(_component_v_list_item, _mergeProps(props, {
                                  title: item.raw.name,
                                  subtitle: item.raw.ip
                                }), {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-ip-network",
                                      color: "grey"
                                    })
                                  ]),
                                  _: 2
                                }, 1040, ["title", "subtitle"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: userInput.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userInput).value = $event)),
                      placeholder: "Escribe un mensaje",
                      variant: "solo-filled",
                      density: "compact",
                      "hide-details": "",
                      rounded: "xl",
                      "bg-color": "#2a2f32",
                      onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (handleSend()), ["enter"])),
                      disabled: isLoading.value
                    }, null, 8, ["modelValue", "disabled"]),
                    (userInput.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          icon: 'mdi-send',
                          color: 'success',
                          variant: "text",
                          class: "ml-2",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (handleSend())),
                          disabled: isLoading.value
                        }, null, 8, ["disabled"]))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          icon:  isRecording.value ? 'mdi-stop' : 'mdi-microphone',
                          color: isRecording.value ? 'red' : 'primary',
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (isRecording.value ? stopAll() : startAll())),
                          variant: "text",
                          class: "mx-2",
                          disabled: isLoading.value
                        }, null, 8, ["icon", "color", "disabled"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})